<div class="container my-5">
    <div class="row">
        <div class="col-12 col-md-12">
                <div class="d-flex justify-content-center">
                    <div *ngIf="id=='calles'">
                            <div>
                                <h4>Año evaluado: 2020</h4>
                            </div>
                            <div class="col-12 text-left my-1">
                                <a  class="fs24 d-block est" target="_blank"
                                    href="https://nld.gob.mx/assets/documentos/variable1.pdf">4.4.1 Tasa de abatimiento de
                                    calles sin revestimiento (V1)</a>
                                <a  class="fs24 d-block est my-1" target="_blank"
                                    href="https://nld.gob.mx/assets/documentos/Variable2.pdf">4.4.1 Tasa de abatimiento de
                                    calles sin revestimiento (V2)</a>
                                <a  class="fs24 d-block est my-1" target="_blank"
                                    href="https://nld.gob.mx/assets/documentos/FORMULA.jpg">FORMULA</a>
                            </div>
                            <br>
                            <div>
                                <h4>Año evaluado: 2021</h4>
                            </div>
                            <div class="col-12 text-left my-1">
                                <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/variable1_2023.pdf">4.4.1 Tasa de
                                    abatimiento de
                                    calles sin revestimiento (V1)</a>
                                <a class="fs24 d-block est my-1" target="_blank" href="https://nld.gob.mx/assets/documentos/variable2_2023.pdf">4.4.1
                                    Tasa de abatimiento de
                                    calles sin revestimiento (V2)</a>
                                <a class="fs24 d-block est my-1" target="_blank" href="https://nld.gob.mx/assets/documentos/FORMULA_2023.pdf">FORMULA</a>
                            </div>
                            <div>
                                <h4>Año evaluado: 2022</h4>
                            </div>
                            <div class="col-12 text-left my-1">
                                <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/variable1_2022_1.pdf">4.4.1
                                    Tasa de
                                    abatimiento de
                                    calles sin revestimiento y Formula </a>
                               
                                
                            </div>
                            <br>
                            <div>
                                <h4>Año evaluado: 2023</h4>
                            </div>
                            <div class="col-12 text-left my-1">
                                <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/variable1_20233.pdf">4.4.1
                                    Tasa de
                                    abatimiento de
                                    calles sin revestimiento y Formula </a>
                            
                            
                            </div>
                            <br>
                            <div>
                                <h4>Año evaluado: 2023</h4>
                            </div>
                            <div class="col-12 text-left my-1">
                                <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/variable1_20233.pdf">4.4.1
                                    Tasa de
                                    abatimiento de
                                    calles sin revestimiento y Formula </a>
                            
                            
                            </div>
                            <br>
                            <div>
                                <h4>Año evaluado: 2024</h4>
                            </div>
                            <div class="col-12 text-left my-1">
                                <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/variable1_2024.pdf">4.4.1
                                    Tasa de
                                    abatimiento de
                                    calles sin revestimiento (V1)</a>
                                <a class="fs24 d-block est my-1" target="_blank"
                                    href="https://nld.gob.mx/assets/documentos/variable2_2024.pdf">4.4.1
                                    Tasa de abatimiento de
                                    calles sin revestimiento (V2)</a>
                                <a class="fs24 d-block est my-1" target="_blank"
                                    href="https://nld.gob.mx/assets/documentos/FORMULA_2024.pdf">FORMULA</a>
                            </div>
                    </div>
                    <div *ngIf="id=='alumbrado'">
                        <div>
                           <h4>2022</h4>
                        </div>
                        <div class="col-12 text-center my-1">
                            <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/4.4.9 Cobertura en el Servicio de Alumbrado Publico.pdf">
                                4.4.9 Cobertura en el Servicio de Alumbrado Publico
                            </a>
                            <a class="fs24 d-block est my-1" target="_blank" href="https://nld.gob.mx/assets/documentos/5.3.4 Abatimiento del costo promedio por luminaria.pdf">
                                    5.3.4 Abatimiento del costo promedio por luminaria
                            </a>
                           
                        </div>
                        <br>
                        <div>
                            <h4>2023</h4>
                        </div>
                        <div class="col-12 text-center my-1">
                            <a class="fs24 d-block est" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.8 Cobertura en el servicio de alumbrado publico.pdf">
                                4.4.8 Cobertura en el Servicio de Alumbrado Publico
                            </a>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/5.3.4 ABATIMIENTO DEL COSTO PROMEDIO POR LUMINARIA.pdf">
                                5.3.4 Abatimiento del costo promedio por luminaria
                            </a>
                        
                        </div>
                        <br>
                        <div>
                            <h4>2024</h4>
                        </div>
                        <div class="col-12 text-center my-1">
                            <a class="fs24 d-block est" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.8 COBERTURA EN EL SERVICIO DE ALUMBRADO PUBLICO_2024.pdf">
                                4.4.8 Cobertura en el Servicio de Alumbrado Publico
                            </a>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/5.3.4 ABATIMIENTO DEL COSTO PROMEDIO POR LUMINARIA_2024.pdf">
                                5.3.4 Abatimiento del costo promedio por luminaria
                            </a>
                        
                        </div>
                        <div class="col-12 text-center my-1">
                            <a class="fs24 d-block est" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.8 COBERTURA EN EL SERVICIO DE ALUMBRADO PUBLICO_2025.pdf">
                                4.4.8 Cobertura en el Servicio de Alumbrado Publico
                            </a>
                            
                        
                        </div>
                    </div>
                    <div *ngIf="id=='limpieza'">
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2022</h4>
                            </div>
                            <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/TEMA 4.4.EVALUACION HOJA 1.pdf">
                                4.4 EVALUACION HOJA 1
                            </a>
                            <a class="fs24 d-block est my-1" target="_blank" href="https://nld.gob.mx/assets/documentos/TEMA 4.4 EVALUACION HOJA 2.pdf">
                                4.4 EVALUACION HOJA 2</a>
                    
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2023</h4>
                            </div>
                            <a class="fs24 d-block est" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.2.3 Situacion de limpia, recoleccion, traslado, tratamiento y disposicion final de residuos.pdf">
                                4.2.3 Situación de limpia, recolección, traslado, tratamiento y disposición final de residuos.
                            </a>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.2 DIAGNOSTICO Situacion de limpia, recoleccion, traslado, tratamiento y disposicion final de residuos.pdf">
                            4.2 DIAGNOSTICO Situacion de limpia, recolección, traslado, tratamiento y disposición final de residuos.pdf</a>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.6 Cobertura del servicio de recoleccion de residuos solidosS.pdf">
                            4.4.6 Cobertura del servicio de recoleccion de residuos solidos</a>
                        
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2024</h4>
                            </div>
                          
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.2 DIAGNOSTIVO_2024.pdf">
                                4.2 DIAGNOSTICO Situacion de limpia, recolección, traslado, tratamiento y disposición final de residuos.pdf</a>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.6 COBERTURA DEL SERVICIO DE RECOLECCION DE RESIDUOS SOLIDOS_2024.pdf">
                                4.4.6 Cobertura del servicio de recoleccion de residuos solidos</a>
                        
                        </div>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2025</h4>
                            </div>
                        
                          
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.6 COBERTURA DEL SERVICIO DE RECOLECCION DE RESIDUOS SOLIDOS_2025.pdf">
                                4.4.6 Cobertura del servicio de recoleccion de residuos solidos</a>
                        
                        </div>
                    </div>
                  
                        
                    
                    <div *ngIf="id=='panteones'">
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2022</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/evalucioncontinuacion.pdf">
                                4.4 EVALUACION HOJA 1</a>
                                <a class="fs24 d-block est" target="_blank" href="https://nld.gob.mx/assets/documentos/evaluacion4.4.pdf">
                                    4.4 EVALUACION HOJA 2
                                </a>
                    
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2023</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4 COBERTURA EN EL SERVICIO.pdf">
                                4.4 COBERTURA EN EL SERVICIO</a>
                           
                        
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2024</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4 COBERTURA EN EL SERVICIO_2024.pdf">
                                4.4 COBERTURA EN EL SERVICIO</a>
                        
                        
                        </div>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2025</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4 COBERTURA EN EL SERVICIO_2025.pdf">
                                4.4 COBERTURA EN EL SERVICIO</a>
                        
                        
                        </div>
                    </div>
                    <div *ngIf="id=='parques'">
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2022</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/INDICADORES DESEMPEÑO PARQUES Y JARDINES.pdf">
                               INDICADORES DESEMPEÑO PARQUES Y JARDINES</a>
                           
                    
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2023</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.7 Tasa de crecimiento anual del indice de areas verdes y recreativas per capita.pdf">
                                4.4.7 Tasa de crecimiento anual del índice de áreas verdes y recreativas per cápita</a>
                        
                        
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2024</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.7.7 TASA DE CRECIMIENTO_2024.pdf">
                                4.4.7 Tasa de crecimiento</a>
                        
                        
                        </div>
                        <br>
                        <div class="col-12 text-left my-1">
                            <div>
                                <h4>2025</h4>
                            </div>
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/4.4.7 Tasa de crecimiento anual del indice de areas verdes y recreativas per capita_2025.pdf">
                                4.4.7 Tasa de crecimiento anual del índice de áreas verdes y recreativas per cápita</a>
                        
                        
                        </div>
                        <br>
                    </div>
                    <div *ngIf="id=='mercado'">
                        <div class="col-12 text-center my-1">
                    
                            <a class="fs24 d-block est my-1" target="_blank"
                                href="https://nld.gob.mx/assets/documentos/INDICADORES_MERCADO.pdf">
                                INDICADORES MERCADO MUNICIPAL NLD</a>
                    
                    
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>